import { useEffect, useState } from "react";
import { General } from "../util/General";

export const useRefetchAPIShortPolling = (shortPollingRefetchTime = 15000) => {
  /* STATES */
  const [shortPollingRefetch, setShortPollingRefetch] = useState<number>(General.getGUID());

  /* EFFECTS */
  useEffect(() => {
    const intervalId = setInterval(() => {
      setShortPollingRefetch(General.getGUID());
    }, shortPollingRefetchTime);

    /* Cleanup on unmount */
    return () => clearInterval(intervalId);
  }, [shortPollingRefetchTime]);

  return {
    shortPollingRefetch
  };
};
